import { render, staticRenderFns } from "./DateSwitcher.vue?vue&type=template&id=4f62d6c3&"
import script from "./DateSwitcher.vue?vue&type=script&lang=js&"
export * from "./DateSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports